import type { PipelineRun } from '@/api/types'

/**
 * A run's draft as the letter and the drafter's notes. Uses the server's split
 * (`draft_parts`); a response from a server that predates it degrades to the
 * whole draft as the letter — never to nothing.
 */
export interface DraftPartsView {
  preamble: string
  letter: string
  grounds_answered: string
  checklist: string
}

export function draftPartsOf(run: Pick<PipelineRun, 'draft' | 'draft_parts'>): DraftPartsView {
  if (run.draft_parts) return run.draft_parts
  return { preamble: '', letter: run.draft ?? '', grounds_answered: '', checklist: '' }
}
